module.exports = __webpack_public_path__ + "img/link.74046b96.svg";